// Cloudinary Configuration
export const cloudinaryConfig = {
  cloud_name: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
  api_key: process.env.REACT_APP_CLOUDINARY_API_KEY,
  upload_preset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
};

// Upload URL
export const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloud_name}/image/upload`;

// Image transformation options
export const getOptimizedImageUrl = (publicId, options = {}) => {
  const defaultOptions = {
    quality: 'auto',
    fetch_format: 'auto',
    width: 400,
    height: 400,
    crop: 'fill',
    gravity: 'auto'
  };
  
  const transformOptions = { ...defaultOptions, ...options };
  const params = Object.entries(transformOptions)
    .map(([key, value]) => `${key}_${value}`)
    .join(',');
    
  return `https://res.cloudinary.com/${cloudinaryConfig.cloud_name}/image/upload/${params}/${publicId}`;
};

// Simple transformation URL (for debugging)
export const getSimpleTransformedUrl = (publicId, width = 150, height = 150) => {
  return `https://res.cloudinary.com/${cloudinaryConfig.cloud_name}/image/upload/c_fill,w_${width},h_${height}/${publicId}`;
};

// Simple URL without transformations (for debugging)
export const getSimpleImageUrl = (publicId) => {
  return `https://res.cloudinary.com/${cloudinaryConfig.cloud_name}/image/upload/${publicId}`;
};

// Thumbnail URL
export const getThumbnailUrl = (publicId) => {
  return getSimpleTransformedUrl(publicId, 150, 150);
};

// Product image URL
export const getProductImageUrl = (publicId) => {
  return getOptimizedImageUrl(publicId, {
    width: 400,
    height: 400,
    crop: 'fill',
    gravity: 'auto'
  });
}; 